<template>
  <div>
    <FeatureGuard feature="marketplace">
      <MarketplacePricingCard
        :product-id="product.id"
        :lead-number="$route.params.lead_number"
        :items="product.marketplace_sessions"
        @destroyed="handleSessionDestroyed"
      />
    </FeatureGuard>

    <v-row>
      <v-col>
        <BudgetPageToolbar
          :title="$capitalize($tc('model.products_replacement_title'))"
          :back-to="productPage"
          :new-to="newVersionPage"
          version-route-name="ProductSubstituitionData"
          :budget-versions="substituitions"
        />
      </v-col>
    </v-row>

    <router-view></router-view>
  </div>
</template>

<script>
import BudgetPageToolbar from "@/components/Budget/BudgetPageToolbar";
import MarketplacePricingCard from "@/components/products/MarketplacePricingCard.vue";
import FeatureGuard from "@/components/featureFlags/FeatureGuard.vue";

export default {
  components: {
    BudgetPageToolbar,
    MarketplacePricingCard,
    FeatureGuard,
  },

  data() {
    return {
      productPage: {
        name: "ProductPageData",
      },
      newVersionPage: {
        name: "ProductNewSubstituition",
      },
    };
  },
  methods: {
    handleSessionDestroyed(id) {
      this.product = {
        ...this.product,
        marketplace_sessions: this.product.marketplace_sessions.filter(
          (i) => i.id !== id
        ),
      };
    },
  },
  computed: {
    substituitions() {
      return this.$store.getters["product/getSubstituitions"];
    },
    product: {
      get() {
        return this.$store.getters["product/getProduct"];
      },
      set(value) {
        return this.$store.commit("product/setProduct", value);
      },
    },
  },
};
</script>
